//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 17.10.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngTableColumnFileSizeFilter', srsngTableColumnFileSizeFilter);

    function srsngTableColumnFileSizeFilter($timeout) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/mega-table/filter/file-size/file-size.html',
            scope: {
                data: '='
            },
            controller: controller,
            link: link
        };

        function controller($scope, FileSizeUnit) {

            $scope.sizeUnits = [
                {label: 'KB', value: FileSizeUnit.KB},
                {label: 'MB', value: FileSizeUnit.MB},
                {label: 'GB', value: FileSizeUnit.GB},
                {label: 'TB', value: FileSizeUnit.TB}
            ];

            $scope.updateSize = size => {

                setSize(size, size.value, size.unit);
                $scope.filter();
            };

            $scope.sort = direction => {

                $scope.filter();
            };

            $scope.search = () => {

                $scope.filter();
            };

            $scope.filter = () => {
                $scope.data.callback($scope.data);
            };

            $scope.reset = () => {

                $scope.data.fromSize = _.cloneDeep($scope.data.originalFromSize);
                $scope.data.toSize = _.cloneDeep($scope.data.originalToSize);
                $scope.filter();
            };

            init();

            function init() {

                if ($scope.data.fromSize == null) {

                    $scope.data.fromSize = {
                        name: 'from',
                        label: 'From'
                    };

                    setSize($scope.data.fromSize, null, $scope.sizeUnits[0]);
                    $scope.data.originalFromSize = _.cloneDeep($scope.data.fromSize);
                }

                if ($scope.data.toSize == null) {

                    $scope.data.toSize = {
                        name: 'to',
                        label: 'To'
                    };

                    setSize($scope.data.toSize, null, $scope.sizeUnits[$scope.sizeUnits.length - 1]);
                    $scope.data.originalToSize = _.cloneDeep($scope.data.toSize);
                }
            }

            function setSize(size, value, unit) {

                size.unit = unit;
                size.value = value;
                size.bytes = value == null || value == '' ? null : value * getUnitCoeff(size.unit);
            }

            function getUnitCoeff(unit) {

                switch (unit.value) {
                    case FileSizeUnit.KB: default: return 1024;
                    case FileSizeUnit.MB: return Math.pow(1024, 2);
                    case FileSizeUnit.GB: return Math.pow(1024, 3);
                    case FileSizeUnit.TB: return Math.pow(1024, 4);
                }
            }
        }

        function link(scope, element, attrs) {

            element.on('$destroy', function () {
                scope.$evalAsync(function () {
                    scope.$destroy();
                });
            });
        }
    }
})();
